import React from 'react';
import { 
  UsersIcon, 
  PhoneIcon, 
  CurrencyDollarIcon,
  ArrowUpIcon,
  ArrowDownIcon 
} from '@heroicons/react/24/outline';

function Dashboard() {
  // Static data for demonstration
  const stats = [
    {
      name: 'Total Users',
      value: '0.00',
      change: '+0.00%',
      changeType: 'increase',
      icon: UsersIcon,
    },
    {
      name: 'Active Campaigns',
      value: '0.00',
      change: '+0.00%',
      changeType: 'increase',
      icon: PhoneIcon,
    },
    {
      name: 'Total Revenue',
      value: '0.00',
      change: '-0.00%',
      changeType: 'decrease',
      icon: CurrencyDollarIcon,
    },
  ];

  const recentTransactions = [
    {
      id: 1,
      user: 'John Doe',
      amount: '0.00',
      status: 'Completed',
      date: '2024-03-15',
    },
    {
      id: 2,
      user: 'Alice Smith',
      amount: '0.00',
      status: 'Pending',
      date: '2024-03-14',
    },
    {
      id: 3,
      user: 'Bob Johnson',
      amount: '0.00',
      status: 'Completed',
      date: '2024-03-14',
    },
    {
      id: 4,
      user: 'Emma Wilson',
      amount: '0.00',
      status: 'Failed',
      date: '2024-03-13',
    },
  ];

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      {/* Stats Section */}
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 mb-8">
        {stats.map((item) => (
          <div
            key={item.name}
            className="bg-white overflow-hidden shadow rounded-lg p-6"
          >
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <item.icon className="h-8 w-8 text-gray-400" />
              </div>
              <div className="ml-5 w-0 flex-1">
                <dl>
                  <dt className="text-sm font-medium text-gray-500 truncate">
                    {item.name}
                  </dt>
                  <dd className="flex items-baseline">
                    <div className="text-2xl font-semibold text-gray-900">
                      {item.value}
                    </div>
                    <div className={`ml-2 flex items-baseline text-sm font-semibold ${
                      item.changeType === 'increase' ? 'text-green-600' : 'text-red-600'
                    }`}>
                      {item.changeType === 'increase' ? (
                        <ArrowUpIcon className="h-4 w-4 flex-shrink-0" />
                      ) : (
                        <ArrowDownIcon className="h-4 w-4 flex-shrink-0" />
                      )}
                      <span className="ml-1">{item.change}</span>
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Recent Transactions Section */}
      {/* <div className="bg-white shadow rounded-lg">
        <div className="px-4 py-5 sm:px-6">
          <h3 className="text-lg font-medium leading-6 text-gray-900">
            Recent Transactions
          </h3>
        </div>
        <div className="border-t border-gray-200">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    User
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Amount
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Date
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {recentTransactions.map((transaction) => (
                  <tr key={transaction.id}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {transaction.user}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {transaction.amount}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm">
                      <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                        transaction.status === 'Completed'
                          ? 'bg-green-100 text-green-800'
                          : transaction.status === 'Pending'
                          ? 'bg-yellow-100 text-yellow-800'
                          : 'bg-red-100 text-red-800'
                      }`}>
                        {transaction.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {transaction.date}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default Dashboard;